import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import {
  Space,
  Table,
  Pagination,
  Row,
  Col,
  Button,
  DatePicker,
  Tooltip,
  Form,
  Select,
} from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { NavLink, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import LoginChecked from "../Shared/LoginChecked";

function DateWiseSummary() {
  const { RangePicker } = DatePicker;
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");
  const [EndDate, SetEndDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [StartDate, SetStartDate] = useState(dayjs().subtract(1, "month").format("YYYY-MM-DD"));
  const [summaryReport, setSummaryreport] = useState([]);
  const [cashAccountId, setCashAccountId] = useState(() => {
    const v = searchParams.get("account_id");
    const n = v ? parseInt(v, 10) : 0;
    return Number.isNaN(n) ? 0 : n;
  });
  const [cashAccounts, setCashAccounts] = useState([]);
  const [resolvedCashLabel, setResolvedCashLabel] = useState("");

  useEffect(() => {
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      Account_Type_ID: 1,
    };
    axios({
      method: "post",
      url: config.base_url + "account/GetAccountsByType",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setCashAccounts(response.data.listofAccounts || []);
        }
      })
      .catch(function () {});
  }, [UserID, AccessKey]);

  useEffect(() => {
    document.title = "Datewise Summary";
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      StartDate: StartDate,
      EndDate: EndDate,
    };
    if (cashAccountId > 0) {
      data.ID = cashAccountId;
    }

    var api_config = {
      method: "post",
      url: config.base_url + "Report/DateWiseSummaryReport",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setSummaryreport(response.data.ListofSummary || []);
          const name =
            response.data.CashAccountName ?? response.data.cashAccountName;
          setResolvedCashLabel(name != null && name !== "" ? name : "");
        } else {
          setSummaryreport([]);
          setResolvedCashLabel("");
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setSummaryreport([]);
        setResolvedCashLabel("");
        setLoading(false);
      });
  }, [StartDate, EndDate, cashAccountId]);

  const onDateChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      SetStartDate(dates[0].format("YYYY-MM-DD"));
      SetEndDate(dates[1].format("YYYY-MM-DD"));
    }
  };

  const onCashAccountChange = (value) => {
    const id = value ? Number(value) : 0;
    setCashAccountId(id);
    if (id > 0) {
      setSearchParams({ account_id: String(id) });
    } else {
      setSearchParams({});
    }
  };

  const columns = [
    {
      title: "Sr.#",
      dataIndex: "Sr",
      key: "Sr",
      render: (_, record, index) => index + 1,
    },
    {
      title: "Dated",
      dataIndex: "Dated",
      key: "Dated",
      render: (_, record) => dayjs(record.Dated).format(config.date_format),
    },
    {
      title: "Opening Cash",
      dataIndex: "Opening_Cash",
      key: "OpeningCash",
      align: "right",
    },
    {
      title: "Cash Sales",
      dataIndex: "Cash_Sales",
      key: "CashSales",
      align: "right",
    },
    {
      title: "Credit Sales",
      dataIndex: "Credit_Sales",
      key: "CreditSales",
      align: "right",
    },
    {
      title: "Cash Purchases",
      dataIndex: "Cash_Purchase",
      key: "CashPurchases",
      align: "right",
    },
    {
      title: "Credit Purchases",
      dataIndex: "Credit_Purchase",
      key: "CreditPurchases",
      align: "right",
    },
    {
      title: "Total Receipts",
      dataIndex: "Total_Receipts",
      key: "TotalReceipts",
      align: "right",
    },
    {
      title: "Total Payments",
      dataIndex: "Total_Payments",
      key: "TotalPayments",
      align: "right",
    },
    {
      title: "Total Expenses",
      dataIndex: "Total_Expenses",
      key: "TotalExpenses",
      align: "right",
    },
    {
      title: "Closing Cash",
      dataIndex: "Closing_Cash",
      key: "ClosingCash",
      align: "right",
    },
    // {
    //   title: "Action",
    //   dataIndex: "Action",
    //   key: "Action",
    // },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
          <Tooltip title="Print 1">
            <NavLink
              to={`/report-datewiseSummary/print-list/?Dated=${dayjs(
                record.Dated
              ).format("YYYY-MM-DD")}`}
              target="_blank"
            >
              <PrinterOutlined /> 1
            </NavLink>
          </Tooltip>
          <br />
          <Tooltip title="Print 2">
            <NavLink to={`/report-datewiseSummary2/print-list/?Dated=${dayjs(
                record.Dated
              ).format("YYYY-MM-DD")}`} target="_blank">
              <PrinterOutlined /> 2
            </NavLink>
          </Tooltip>
        </>
      ),
    },
  ];


  const disableDate = (current) => {
    return current && current > dayjs().endOf("day");
  };

  return (
    <>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">DateWise Summary</h3>
            {resolvedCashLabel ? (
              <p className="text-muted" style={{ marginTop: 4, marginBottom: 0 }}>
                Cash ledger: <strong>{resolvedCashLabel}</strong>
                {cashAccountId > 0 ? (
                  <>
                    {" "}
                    <NavLink
                      to={`/accounts/account-ledger/?account_id=${cashAccountId}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Open same account in ledger
                    </NavLink>
                  </>
                ) : null}
              </p>
            ) : null}

            <div className="header-actions">
              <NavLink to={`/report-datewiseSummary-all/print-list/?StartDate=${StartDate}&EndDate=${EndDate}`} target="_blank">
                <Button
                  type="dashed"
                  size="large"
                  shape="round"
                  // style={{ marginBottom: 10 }}
                >
                  <PrinterOutlined />
                  Print Report
                </Button>
              </NavLink>
            </div>
          </div>
          <div className="filter-wrap">
            <Form layout="inline">
              <Form.Item label="Cash account">
                <Select
                  allowClear
                  placeholder="Default cash account"
                  style={{ minWidth: 220 }}
                  value={cashAccountId > 0 ? cashAccountId : undefined}
                  onChange={onCashAccountChange}
                  options={cashAccounts.map((a) => ({
                    value: a.ID,
                    label: a.Name,
                  }))}
                />
              </Form.Item>
              <Form.Item>
                <RangePicker
                  value={[dayjs(StartDate), dayjs(EndDate)]}
                  onChange={onDateChange}
                  disabledDate={disableDate}
                />
              </Form.Item>
            </Form>
          </div>
          <Table
            size="small"
            scroll={{
              x: "100%",
            }}
            loading={loading}
            rowKey={(record) =>
              record.Dated
                ? dayjs(record.Dated).format("YYYY-MM-DD")
                : String(record.SerialNo ?? record.Sr)
            }
            columns={columns}
            dataSource={summaryReport}
            // onChange={handleTableChange}
            pagination={false}
            bordered
          />
        </div>
      </div>
    </>
  );
}

export default DateWiseSummary;
